import { AxiosResponse } from "axios";
import { call, put, select, takeLatest } from "redux-saga/effects";
import { AppService } from "src/services/app";
import { getBaseUrl } from "../selectors/features/app";
import {
  deleteWorkingDaysFailure,
  deleteWorkingDaysSuccess,
} from "../slices/features/workingDays";
import { RequestTypes } from "../types";

const appservice = new AppService();

function* deleteWorkingDaysSaga(action: any) {
  const { payload } = action;
  const { id } = payload;
  try {
    const baseUrl: string = yield select(getBaseUrl);

    const response: AxiosResponse<any> = yield call(
      appservice.deleteWorkingDays,
      baseUrl,
      id
    );

    yield put(deleteWorkingDaysSuccess({ ...response }));

    payload?.cbSuccess && payload?.cbSuccess(response);
  } catch (error: any) {
    const { statusCode, statusText } = error;

    const message = error?.data?.errors?.message;

    payload?.cbFailure && payload?.cbFailure(message);

    yield put(deleteWorkingDaysFailure({ statusCode, statusText }));
  }
}

export function* watchDeleteWorkingDays() {
  yield takeLatest(
    RequestTypes.DELETE_WORKING_DAYS_REQUEST,
    deleteWorkingDaysSaga
  );
}
